
import { Options, Prop, Vue } from "vue-property-decorator";
import { VoteSponsorship } from "@/api";
import { Check, Cross } from "@rtl/ui";
import { ResponsiveImage } from "@/views/components";

@Options({
  components: {
    Yes: Check,
    No: Cross,
    ResponsiveImage,
  },
})
export default class VoteSubject extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  readonly name!: string;

  @Prop({
    type: String,
  })
  readonly image: string | undefined;

  @Prop({
    type: String,
  })
  readonly state: "yes" | "no" | undefined;

  @Prop({
    type: Object,
  })
  readonly sponsorship: VoteSponsorship | undefined;

  isContrast(hex: string) {
    const rgbData = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    if (rgbData) {
      const rgb = {
        r: parseInt(rgbData[1], 16),
        g: parseInt(rgbData[2], 16),
        b: parseInt(rgbData[3], 16),
      };
      const rgbDelta =
        Math.round(rgb.r * 299) +
        Math.round(rgb.g * 587) +
        Math.round(rgb.b * 114);

      return rgbDelta / 1000 >= 160;
    }
  }
}
